import { APIEndpoints } from "../../constants";
import { APIPost, getAuthHeaders, APIResponse } from "../api/common.service";
import { COQLRequest, StudentListResponseData } from "../../types";

export function GetStudentList(
  body: COQLRequest
): Promise<APIResponse<StudentListResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<StudentListResponseData>(
      APIEndpoints.GetStudents,
      headers,
      undefined,
      body as unknown as Record<string, unknown>
    )
  );
}
